import {
  provideSoftAppsModule,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { getModuleGroupById, getModuleGroupByName } from '@softline/application';
import { default as de } from '../i18n/de.json';
import { purchaseStatisticsRoutes } from './purchase-statistics.routes';
import { SOFTLINE_PERMISSION_WWS_UMSATZSTATISTIK } from '@softapps/wws/umsatzstatistik';

export const providePurchaseStatisticsModule = () => {
  return [
    provideSoftAppsModule(
      {
        name: 'PurchaseStatistics',
        title: 'Einkaufsstatistik',
        icon: 'fa-regular fa-chart-pie-simple-circle-dollar',
        route: '/purchase-statistics/dashboard',
        permission: SOFTLINE_PERMISSION_WWS_UMSATZSTATISTIK,
        group: getModuleGroupByName('Statistik'),
      },
      withSoftAppsModuleRoutes({ app: purchaseStatisticsRoutes }),
      withSoftAppsModuleTranslation({ de })
    ),
  ];
};
